import {
  PARTNER_ORDER_CHANGE_TABLE_OPTION,
  PARTNER_ORDER_CHANGE_VALUE, PARTNER_ORDER_SET_ORDER,
} from '@/store/constants/mutationTypes';

const mutations = {
  [PARTNER_ORDER_CHANGE_VALUE]: (state, payload) => {
    const {
      field,
      value,
    } = payload;
    state[field] = value;
  },
  [PARTNER_ORDER_CHANGE_TABLE_OPTION]: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    if (typeof value === 'object') {
      if (value.includes(undefined)) {
        state.partnerOrderTableOptions.sortBy = [];
        state.partnerOrderTableOptions.sortDesc = [];
      }
    }
    state.partnerOrderTableOptions[field] = value;
  },
  [PARTNER_ORDER_SET_ORDER]: (state, payload) => {
    const {
      partnerOrders,
    } = payload;
    state.partnerOrders = partnerOrders;
    state.loadingOrder = false;
  },
};

export default mutations;
